import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    allCaseTracking: [],
};

const actions = {
    async fetchAllCaseTracking({ commit }) {

        await db.collection('/case_tracking/local/general_cases').get().then(
            (snapshot) => {
                var allCaseTracking = [];
                snapshot.forEach(doc => {
                    allCaseTracking.push({...doc.data(), id:doc.id})
                });
                commit("updateField", {
                    path: "allCaseTracking",
                    value: allCaseTracking,
                })
            });
    },
    async updateCaseTracking({ commit }, payload) {

        await db.collection('/case_tracking/local/general_cases').get().then(
            (snapshot) => {
                snapshot.forEach(async doc => {
                    if (doc.id === payload.id) {
                        await db.collection('/case_tracking/local/general_cases').doc(doc.id).update({value: payload.value})

                    }
                });

            });
    },
    async fetchAllCaseTracking2({ commit }) {

        await db.collection('/case_tracking/global/general_cases').get().then(
            (snapshot) => {
                var allCaseTracking = [];
                snapshot.forEach(doc => {
                    allCaseTracking.push({...doc.data(), id:doc.id})
                });
                commit("updateField", {
                    path: "allCaseTracking",
                    value: allCaseTracking,
                })
            });
    },
    async updateCaseTracking2({ commit }, payload) {

        await db.collection('/case_tracking/global/general_cases').get().then(
            (snapshot) => {
                snapshot.forEach(async doc => {
                    if (doc.id === payload.id) {
                        await db.collection('/case_tracking/global/general_cases').doc(doc.id).update({value: payload.value})

                    }
                });

            });
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
